import React from "react";
import Hero from "../Hero/Hero";
import HomeServices from "../HomeServices/HomeServices";
import Partners from "../Partners/Partners";

const Home = () => {
  return (
    <div>
      <Hero></Hero>
      <HomeServices></HomeServices>
      <Partners></Partners>
    </div>
  );
};

export default Home;
